import React, { Component, Fragment } from 'preact/compat';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Icon from '../../Svg/Arrow';
import ListItem from '../../Teaser/ListItem';
import importComponent from '../../../lib/importComponent';
import { defaultLocale as DEFAULT_LOCALE } from '../../../data/locales';

const Teaser = styled(ListItem)`
  cursor: pointer;
`;

const AccordionBody = styled.div`
  max-height: ${({ open, maxHeight }) => (open ? maxHeight : '0')};
  overflow: hidden;
  transition: max-height 0.3s;
`;

class AccordionListItem extends Component {
  state = {
    open: false,
  };

  onClick = () => {
    this.setState(prevState => ({
      open: !prevState.open,
    }));
  }

  teaser = () => {
    const {
      title,
      city,
    } = this.props.job;

    return (
      <Teaser
        onClick={this.onClick}
        text={title}
        secondaryText={city}
        meta={
          <Icon active={this.state.open} />
        }
      />
    );
  }

  render() {
    const { open } = this.state;
    const {
      job,
      locale,
      locales,
      maxHeight,
    } = this.props;
    const AccordionListItemContent =
      open ? importComponent(async () =>
        (await import('./AccordionListItemContent')).default) : null;

    return (
      <Fragment>
        {this.teaser()}
        <AccordionBody open={open} maxHeight={maxHeight}>
          <AccordionListItemContent
            job={job}
            locale={locale}
            locales={locales}
          />
        </AccordionBody>
      </Fragment>
    );
  }
}

AccordionListItem.propTypes = {
  job: PropTypes.shape({
    title: PropTypes.string,
    locales: PropTypes.arrayOf(PropTypes.string),
    country: PropTypes.string,
    description: PropTypes.node,
    city: PropTypes.string,
    universalForm: PropTypes.bool,
    applyUrl: PropTypes.string,
    company: PropTypes.shape({
      description: PropTypes.node,
    }),
    template: PropTypes.shape({
      source: PropTypes.string,
    }),
    properties: PropTypes.arrayOf(PropTypes.shape()),
  }),
  maxHeight: PropTypes.string,
  locale: PropTypes.string,
  locales: PropTypes.arrayOf(PropTypes.string),
};

AccordionListItem.defaultProps = {
  job: {
    title: undefined,
    locales: [],
    country: undefined,
    description: undefined,
    city: undefined,
    universalForm: true,
    applyUrl: undefined,
    company: {
      description: undefined,
    },
    template: {
      source: undefined,
    },
    properties: [{}],
  },
  maxHeight: '900em',
  locale: DEFAULT_LOCALE,
  locales: [],
};

export default AccordionListItem;
